import { RouteConfig } from 'vue-router';

const applicationRouter: RouteConfig[] = [
  {
    name: 'Application',
    path: '/application/index',
    component: () =>
      import(
        /* webpackChunkName: "Application" */
        '@/views/application/index.vue'
      ),
    meta: { title: '' },
  },
];

export default applicationRouter;
